"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var IPPhoneShare = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_IPPhoneShare_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.091 16H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h10.5A2.5 2.5 0 0 1 16 2.5v7.288l-1-1.035V2.5A1.5 1.5 0 0 0 13.5 1H5.236C5.711 1.53 6 2.232 6 3v10c0 .768-.289 1.47-.764 2h1.718a5.847 5.847 0 0 0 .137 1ZM5 3v10a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.987 10.161a5.998 5.998 0 0 0-.762.814 1 1 0 1 1 .762-.814Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6.5c0 .396-.154.757-.405 1.025a1.435 1.435 0 0 0-.986.02 1.409 1.409 0 0 0-.602.455H8.5A1.5 1.5 0 0 1 7 6.5v-3A1.5 1.5 0 0 1 8.5 2h4A1.5 1.5 0 0 1 14 3.5v3ZM8.5 3h4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.102 15.702A4.871 4.871 0 0 1 8 14.713c0-2.72 2.149-4.946 4.776-4.946v-.919c0-.318.375-.46.614-.247l2.457 2.544a.525.525 0 0 1 0 .742l-1.57 1.66-.887.919c-.205.212-.58.07-.58-.247v-.92c-1.774 0-3.275 1.026-4.06 2.51-.17.317-.58.211-.648-.107Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_IPPhoneShare_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = IPPhoneShare;
exports["default"] = _default;